const ADMIN_EDIT_USER = "user::admin::edit";
const CHANGE_PASSWORD = "user::change-password";
const EDIT_USER = "user::edit";
const EDIT_USER_SUCCESS = "user::edit::success";
const FORGOT_PASSWORD = "user::forgot-password";
const INVITE_USER = "user::invite";
const LOAD_USERS = "users::load::fetch";
const LOAD_USERS_FAILURE = "users::load::failure";
const LOAD_USERS_SUCCESS = "users::load::success";
const REGISTER_USER = "user::register";
const RESET_PASSWORD = "user::reset-password";
const USER_INVITE_DETAILS = "user::invite-details";

export {
  ADMIN_EDIT_USER,
  CHANGE_PASSWORD,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  FORGOT_PASSWORD,
  INVITE_USER,
  LOAD_USERS,
  LOAD_USERS_FAILURE,
  LOAD_USERS_SUCCESS,
  REGISTER_USER,
  RESET_PASSWORD,
  USER_INVITE_DETAILS,
};
